import { Injectable } from '@angular/core'
import { GroupBy } from '../model/hierarchy-menu.model'

@Injectable({ providedIn: 'root' })
export class GroupbyIconService {
    getIconByGroupBy = (groupBy: GroupBy): string => {
        switch (groupBy) {
            case 'employee':
                return 'person'
            case 'day':
                return 'event'
            case 'month':
                return 'date_range'
            case 'year':
                return 'av_timer'
            case 'timesheetProject':
            case 'timesheetProjectClient':
                return 'stars'
            case 'client':
                return 'filter_none'
            case 'tag':
                return 'local_offer'
            case 'state':
                return 'flag'
            default:
                return 'error' // not found
        }
    }
}
